import {
  Body2,
  Box,
  Button,
  ButtonGroup,
  Display3,
  Flex,
} from '@sainsburys-tech/fable'
import { AlertCircleFilled } from '@sainsburys-tech/icons'
import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import parseErrorStack from '../../utils/errors'
interface IError<T> {
  message: string
  actions?: [
    {
      handler: () => T
      title: string
    },
  ]
}

const onReload = () => {
  window.location.href = window.location.origin
}

function MaintenancePage<T>({ message, actions }: IError<T>) {
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const queryMessage = queryParams.get('message')

  useEffect(() => {
    const errorStack = parseErrorStack(new Error(message))
    if (errorStack && errorStack.length > 0) {
      console.log(message, JSON.stringify(errorStack, null, 2))
    }
  }, [message, actions])

  return (
    <>
      <Box
        className='maintenance-page'
        data-testid='maintenance-page'
        backgroundColor='primary'
      >
        <Flex
          direction='column'
          alignItems='center'
          gap='lg'
          style={{ minHeight: 'calc(100vh - 56px)' }}
        >
          <Box
            backgroundColor='secondary'
            padding={{ sm: 'md', md: 'lg' }}
            style={{
              maxWidth: 1500,
              width: '100%',
              marginTop: '2rem',
              boxSizing: 'border-box',
            }}
          >
            <Flex
              direction='column'
              alignItems='center'
              justifyContent='center'
              gap='sm'
            >
              <AlertCircleFilled className='c-common-error_icon-larger' />
              <div className='c-common-error_primaryMessage'>
                <Display3
                  style={{
                    textAlign: 'center',
                    marginTop: '8px',
                    marginBottom: '16px',
                  }}
                >
                  503 Service Unavailable.
                </Display3>
              </div>
              <div>
                {queryMessage ? (
                  <div
                    data-testid='errorMessage'
                    style={{
                      textAlign: 'center',
                      fontSize: '1.1rem',
                      margin: 0,
                      marginBottom: 8,
                    }}
                  >
                    {queryMessage}
                  </div>
                ) : (
                  <div data-testid='errorMessage'>
                    <Body2
                      style={{
                        textAlign: 'center',
                        margin: 0,
                        marginBottom: 8,
                      }}
                    >
                      Production Planning is currently being updated. This may
                      take up to an hour.
                    </Body2>
                  </div>
                )}
              </div>
              <ButtonGroup align='center' gap='lg'>
                <Button onClick={() => onReload()} testid='refresh-button'>
                  Refresh
                </Button>
                {actions &&
                  actions.length > 0 &&
                  actions.map((x, i) => (
                    <Button
                      key={i}
                      onClick={() => x.handler()}
                      testid={`action-button-${i}`}
                    >
                      {x.title}
                    </Button>
                  ))}
              </ButtonGroup>
            </Flex>
          </Box>
        </Flex>
      </Box>
    </>
  )
}

export default MaintenancePage
